import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { useBooking } from "../context/BookingContext";
import { imgUrl } from "../lib/spa";

export const MassageCard = ({ massage }) => {
  const { t, ml } = useLanguage();
  const { openBooking } = useBooking();

  return (
    <div
      data-testid={`massage-card-${massage.slug}`}
      className="group overflow-hidden rounded-2xl border border-foreground/8 bg-card transition-colors duration-300 hover:border-gold/30"
    >
      <Link to={`/massagens/${massage.slug}`} className="block overflow-hidden">
        <div className="relative aspect-[4/3] overflow-hidden">
          <img
            src={imgUrl(massage.cover)}
            alt={ml(massage.name)}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          />
          <span className="absolute left-4 top-4 flex items-center gap-1.5 rounded-full bg-black/60 px-3 py-1.5 text-[10px] uppercase tracking-widest text-white/80 backdrop-blur-sm">
            <Clock className="h-3 w-3 text-gold" strokeWidth={1.5} />
            {massage.duration}
          </span>
          {ml(massage.badge) && (
            <span
              data-testid={`massage-badge-${massage.slug}`}
              className="absolute right-4 top-4 rounded-full bg-gold px-3 py-1.5 text-[9px] font-bold uppercase tracking-[0.18em] text-black shadow-lg shadow-black/30"
            >
              {ml(massage.badge)}
            </span>
          )}
        </div>
      </Link>
      <div className="p-6">
        <h3 className="font-display text-2xl font-medium text-foreground transition-colors duration-300 group-hover:text-gold">
          {ml(massage.name)}
        </h3>
        <p className="mt-3 line-clamp-3 text-sm leading-relaxed text-foreground/72">
          {ml(massage.description)}
        </p>
        <div className="mt-5 flex items-center justify-between">
          <Link
            data-testid={`massage-details-${massage.slug}`}
            to={`/massagens/${massage.slug}`}
            className="group/link inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-gold"
          >
            {t("services.details")}
            <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover/link:translate-x-1" strokeWidth={1.5} />
          </Link>
          <button
            data-testid={`massage-book-${massage.slug}`}
            onClick={() => openBooking({ massageSlug: massage.slug })}
            className="rounded-full border border-foreground/15 px-4 py-2 text-[10px] uppercase tracking-[0.2em] text-foreground/82 transition-all duration-300 hover:border-gold hover:text-gold"
          >
            {t("services.book")}
          </button>
        </div>
      </div>
    </div>
  );
};
